import React from 'react';
import { useSelector } from 'react-redux';
import ReactLoader from 'react-loading';

import styled from '@mui/material/styles/styled';
import { default as MuiBackdrop } from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import logo from '../../assets/images/LightLevel_by_Veregy.svg';

const Logo = styled('img')(({ theme }) => ({
  margin: theme.spacing(8),
}));

const LoaderComponent = styled(ReactLoader)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export default function Backdrop() {
  const { loaderOpen } = useSelector((state) => state.pages);

  return (
    <MuiBackdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loaderOpen}>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <Stack
          sx={(theme) => ({
            backgroundColor: theme.palette.background.default,
            borderRadius: theme.spacing(1),
            justifyContent: 'center',
            alignItems: 'center',
          })}>
          <Logo src={logo} alt='lightlevel logo' width={500} />
          <LoaderComponent
            type={'spin'}
            color={'grey'}
            height='10%'
            width='10%'
          />
        </Stack>
      </Box>
    </MuiBackdrop>
  );
}
